import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMilkCarton = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "milk-carton_icon",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M6 3.5h12a.5.5 0 0 0 .5-.5v-.5a2.793 2.793 0 0 0-3-2.5h-7a2.793 2.793 0 0 0-3 2.5V3a.5.5 0 0 0 .5.5" }),
		/* @__PURE__ */ _jsx("path", { d: "M12.75 11.5H.5a.5.5 0 0 0-.5.5v10.5A1.5 1.5 0 0 0 1.5 24h11.25a.5.5 0 0 0 .5-.5V12a.5.5 0 0 0-.5-.5m-2.25 6a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.8 5.3a.5.5 0 0 0-.458-.3H5.5a.5.5 0 0 0-.371.165l-3.615 4a.5.5 0 0 0 .371.835h11.794a.5.5 0 0 0 .369-.162l3.667-4A.5.5 0 0 0 17.8 5.3" }),
		/* @__PURE__ */ _jsx("path", { d: "m23.578 10.372-3.6-3.978a.5.5 0 0 0-.74 0l-4.361 4.758a.5.5 0 0 0-.131.338V23.5a.5.5 0 0 0 .5.5H22.5a1.5 1.5 0 0 0 1.5-1.5V11.414a1.5 1.5 0 0 0-.422-1.042" })
	]
});
export { SvgMilkCarton as ReactComponent };
